var _excluded = ["horizontal", "divided"];

var _templateObject;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
var StyledList = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  width: 100%;\n  padding: 0;\n  margin: 0;\n\n  list-style: none;\n\n  ", "\n"])), function (_ref) {
  var divided = _ref.divided,
      horizontal = _ref.horizontal,
      list = _ref.theme.yoga.components.list;
  return "\n    flex-direction: " + (horizontal ? 'row' : 'column') + ";\n\n    > * {\n        " + (divided ? "border-" + (horizontal ? 'right' : 'bottom') + ": " + list.border.width + "px solid " + list.border.color : '') + ";\n\n        &:last-child {\n          border: none;\n        }\n      }\n    }\n  ";
});
/** Lists are a continuous group of text or images. They are composed of items
containing primary and supplemental actions, which are represented by icons and
text. */

var List = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var horizontal = _ref2.horizontal,
      divided = _ref2.divided,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledList, _extends({
    horizontal: horizontal,
    divided: divided,
    ref: ref
  }, rest));
});
List.propTypes = {
  horizontal: PropTypes.bool,
  divided: PropTypes.bool
};
List.defaultProps = {
  horizontal: false,
  divided: true
};
List.displayName = 'List';
export default List;